export default __webpack_public_path__ + "static/media/contactRead.9ca3656e.svg";